import React from 'react';
import { NavLink } from 'react-router-dom';

export function closeManualSidebar() {
  document.documentElement.classList.remove('menual-active');
}

export function MLink({
  to,
  children,
  state,
}: {
  to: string;
  children: React.ReactNode;
  state?: object;
}) {
  const isTsp = to.startsWith('/tsp/');
  if (isTsp) {
    return (
      <NavLink to={to} className="menual-link" state={state}>
        {children}
      </NavLink>
    );
  }
  return (
    <a href={to} className="menual-link">
      {children}
    </a>
  );
}
